import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class HealthDashboardRoute extends Route {
  @service featureFlags;
  @service router;

  titleToken = 'Health Dashboard';

  beforeModel() {
    if (!this.featureFlags.isEnabled('integration-health-dashboard')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  async setupController(controller, model) {
    super.setupController(controller, model);
    controller.showLocationFilter = false;
    const locationId = controller.state.currentLocation?.id;
    controller.selectedLocations = locationId != null ? [String(locationId)] : [];
    controller.selectedInstalls = [];
    controller.selectedEventTypes = [];
    controller.selectedIntegrationTypes = [];
    controller.selectedStatuses = [];
    controller.page = 1;
    controller._hiddenEventTypes = [];
    controller._hiddenInstalls = [];
    await controller.fetchData();
    controller.startAutoRefresh();
  }

  deactivate() {
    this.controller.stopAutoRefresh();
  }
}
